import {Resources} from "../../../resources/Resources";
import {ICurrency} from "../../../models/currency/ICurrency";

export function numberPrice(priceCentimes: number, currency: ICurrency, includedTax?: boolean) {
    const negative = priceCentimes < 0;
    const amount = Math.abs(priceCentimes) / 100;
    const formattedPrice = amount.toFixed(2);
    const number = formattedPrice.endsWith("00") ? formattedPrice.substring(0, formattedPrice.length - 3) : formattedPrice;

    const tax = (includedTax == undefined ? "" : includedTax == true
        ? " " + Resources.t("words.offerIncludeTax")
        : " " + Resources.t("words.offerExcludeTax"));

    // Symbole à 2+ caractères (ex. "CA$") → espace pour la lisibilité ("CA$ 185") ; symbole simple collé ("$185", "£185")
    const withSymbol = currency.symbolBefore
        ? currency.symbol + (currency.symbol.length > 1 ? " " : "") + number
        : number + currency.symbol;

    return (negative ? "-" : "") + withSymbol + tax;
}
